/**
 * Модуль конфигов для слайдеров. Получаем объект, у которого ключ должен быть равен ключу
 * переданному в дата-атрибут data-slider-settings="mainPageSlider" обертки с классом js-slider
 * Таким образом можно управлять всеми конфигами в этом файле
 */
itsoftApp.createModule("slidersSettings", function () {
    // Локальные переменные
    const module = this;
    const mobileSlideCount = 1.05;

    const Settings = {
        global: {
            slidesPerView: "auto",
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            speed: 500,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const slider = swiperContainer.closest('.js-slider');
                    const sliderName = swiperContainer.getAttribute("data-slider-name");
                    
                    swiper.params.custom = {
                        swiperContainer: swiperContainer,
                        slider: slider,
                        sliderName: sliderName,
                    }

                    const customParams = swiper.params.custom;

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                    }
                }
            }
        },
 
        formula: { //не принимает имя formula
            slidesPerView: mobileSlideCount,
            simulateTouch: true,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            speed: 500,
            spaceBetween: 16,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const slider = swiperContainer.closest('.js-slider');
                    const sliderName = swiperContainer.getAttribute("data-slider-name");
                    
                    swiper.params.custom = {
                        swiperContainer: swiperContainer,
                        slider: slider,
                        sliderName: sliderName,
                    }

                    const customParams = swiper.params.custom;

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                    }
                }
            },

            breakpoints: {
                768: {
                    slidesPerView: 2,

                },

                1024: {
                    slidesPerView: 4,
                    spaceBetween: 20
                }
            }
        },

        products: {
            slidesPerView: mobileSlideCount,
            simulateTouch: true,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            speed: 500,
            spaceBetween: 16,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const slider = swiperContainer.closest('.js-slider');
                    const sliderName = swiperContainer.getAttribute("data-slider-name");
                    
                    swiper.params.custom = {
                        swiperContainer: swiperContainer,
                        slider: slider,
                        sliderName: sliderName,
                    }

                    const customParams = swiper.params.custom;

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                    }
                }
            },

            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
            },

            breakpoints: {
                768: {
                    slidesPerView: 1.8
                },

                1024: {
                    slidesPerView: 3,
                    spaceBetween: 20
                }
            }
        },

        filters: {
            slidesPerView: "auto",
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            speed: 500,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const slider = swiperContainer.closest('.js-slider');
                    const sliderName = swiperContainer.getAttribute("data-slider-name");
                    
                    swiper.params.custom = {
                        swiperContainer: swiperContainer,
                        slider: slider,
                        sliderName: sliderName,
                    }

                    const customParams = swiper.params.custom;

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                    }
                }
            },

            spaceBetween: 8
        },

        articles: {
            slidesPerView: mobileSlideCount,
            simulateTouch: true,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            speed: 500,
            spaceBetween: 16,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const slider = swiperContainer.closest('.js-slider');
                    const sliderName = swiperContainer.getAttribute("data-slider-name");
                    
                    swiper.params.custom = {
                        swiperContainer: swiperContainer,
                        slider: slider,
                        sliderName: sliderName,
                    }

                    const customParams = swiper.params.custom;

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                    }
                }
            },

            breakpoints: {
                768: {
                    slidesPerView: 2
                },

                1024: {
                    slidesPerView: 4,
                    spaceBetween: 20
                }
            }
        },

        indications: {
            slidesPerView: mobileSlideCount,
            simulateTouch: true,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            speed: 500,
            spaceBetween: 16,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const slider = swiperContainer.closest('.js-slider');
                    const sliderName = swiperContainer.getAttribute("data-slider-name");
                    
                    swiper.params.custom = {
                        swiperContainer: swiperContainer,
                        slider: slider,
                        sliderName: sliderName,
                    }

                    const customParams = swiper.params.custom;

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                    }
                }
            },

            breakpoints: {
                768: {
                    slidesPerView: 2
                },

                1024: {
                    slidesPerView: 4,
                    spaceBetween: 20
                }
            }
        },

        buying: {
            slidesPerView: 2,
            simulateTouch: true,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            speed: 500,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const slider = swiperContainer.closest('.js-slider');
                    const sliderName = swiperContainer.getAttribute("data-slider-name");
                    
                    swiper.params.custom = {
                        swiperContainer: swiperContainer,
                        slider: slider,
                        sliderName: sliderName,
                    }

                    const customParams = swiper.params.custom;

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                    }
                }
            },

            spaceBetween: 8,

            breakpoints: {
                768: {
                    slidesPerView: 4,
                    spaceBetween: 16
                },

                1024: {
                    slidesPerView: 6,
                    spaceBetween: 20
                }
            }
        },

        tabsButtons: {
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            slideToClickedSlide: true,
            slidesPerView: "auto",
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            speed: 500,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const sliderName = swiperContainer.getAttribute("data-slider-name");

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                    }

                    const target = swiperContainer.closest(".js-scroll-trigger.js-hash-nav");

                    if (target) {
                        target.classList.add("js-visible");

                        itsoftApp.modules.scrollActions.callback(target, true, false);
                    }
                }
            }
        },
    };

    const getSettings = function (slidersSettingsKey) {
        return Settings[slidersSettingsKey];
    };

    module.getSettings = getSettings;
});